import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { TicketListView } from '@/hooks/useParentTickets'

type TicketViewState = {
  view: TicketListView
  setView: (view: TicketListView) => void
}

export const useTicketViewStore = create<TicketViewState>()(
  persist(
    (set) => ({
      view: 'all',
      setView: (view) => set({ view }),
    }),
    {
      name: 'ticket-view-storage',
    }
  )
)
